// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--d04Vo","label":"_0d624b9a27--label--dkuPK","icon":"_0d624b9a27--icon--Zy1Ky"};